<template>
  <div class="invalid-pac-search-type-dates">
    <div class="invalid-pac-search-type-dates__body">
      <div class="d-flex">
        <i class="icon icon-position md color-primary" :class="rateAvailableIcon"></i>
        <div class="invalid-pac-search-type-dates__message">
          <span class="invalid-pac-search-type-dates__title" :class="isRateNotAvailable">{{
            label
          }}</span>
        </div>
      </div>

      <div class="btn-custom" :class="isRateAvailable">
        <button
          class="btn cta-btn-custom"
          :disabled="bookingDisabled"
          @click="$emit('checkAvailability', hotel)"
        >
          <span class="button__text" v-if="!loading">
            {{ translate('rdCheckAvailability') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvalidPacSearchTypeDates',
  props: {
    label: String,
    hotel: Object
  },
  computed: {
    rateAvailableIcon() {
      return this.hotel.searchApplicable && !this.hotel.matchesSearch
        ? 'rhg-font-icon--alert'
        : 'rhg-font-icon--calendar-no-availability'
    },
    isRateAvailable() {
      return !this.hotel.searchApplicable > 0 && !this.hotel.matchesSearch ? 'd-none' : ''
    },
    isRateNotAvailable() {
      return !this.hotel.searchApplicable > 0 && !this.hotel.matchesSearch ? 'mt-3' : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-custom {
  margin-left: 4rem;
  margin-right: auto;
  padding-left: 0px;
  margin-top: 1rem;

  .cta-btn-custom {
    padding: 1.6rem 2.4rem;
    line-height: 2rem;
    height: 48px;
    width: 221px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    border-radius: 48px;
    background-color: #c62525;
    margin-left: 100px;
    span {
      color: #ffffff;
    }
  }
  .button__text {
    font-style: normal;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    color: #c62525;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
}

.invalid-pac-search-type-dates {
  display: flex;
  padding: 2.5rem;
  background-color: #fcf0f1;
  flex-direction: row;
  flex-wrap: wrap;

  &__body {
    align-items: center;
    display: flex;
    padding-right: 2rem;
  }
  &__message {
    display: flex;
    padding-right: 2rem;
    padding-left: 2rem;
  }

  &__title {
    font-weight: bold;
    font-size: 16px;
  }

  &__description {
    font-size: 12px;
  }

  &__icon {
    padding-top: 1.5rem;
    padding-right: 2rem;
  }

  &__button {
    padding: 1.6rem 2.4rem;
    line-height: 2rem;
    height: 48px;
    width: 221px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    border-radius: 48px;

    &.btn-color-primary {
      background: #c20808;
    }
  }
}

@media (max-width: 920px) {
  .invalid-pac-search-type-dates__body {
    padding-left: 0px;
    flex-direction: column;
  }
  .invalid-pac-search-type-dates__message {
    padding-left: 1rem;
    padding-right: 0;
  }
  .invalid-pac-search-type-dates__button {
    padding-left: 0px;
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;
  }
  .btn-custom {
    .cta-btn-custom {
      margin-left: 0;
    }
  }
  .icon-position {
    margin-top: 2rem;
  }
}
</style>
